import React from 'react';
import { Modal } from '../../common/Modal';
import { Button } from '../../common/Button';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  title: string;
  message: string;
  saving: boolean;
}

export const DeleteConfirmModal: React.FC<Props> = ({ isOpen, onClose, onConfirm, title, message, saving }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    size="sm"
    footer={
      <>
        <Button variant="outline" size="sm" type="button" onClick={onClose}>Cancel</Button>
        <Button
          size="sm"
          type="button"
          onClick={onConfirm}
          disabled={saving}
          isLoading={saving}
          className="bg-red-600 hover:bg-red-700 text-white shadow-sm"
        >
          Delete
        </Button>
      </>
    }
  >
    <p className="text-sm text-slate-600">{message}</p>
  </Modal>
);
